const now = () => new Date(Date.now());

export default now;
